import { render } from "./WebSwiper.vue?vue&type=template&id=41c2e757"
import script from "./WebSwiper.vue?vue&type=script&lang=js"
export * from "./WebSwiper.vue?vue&type=script&lang=js"

import "./WebSwiper.vue?vue&type=style&index=0&id=41c2e757&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSlider from 'quasar/src/components/slider/QSlider.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QCarouselControl from 'quasar/src/components/carousel/QCarouselControl.js';
import QResizeObserver from 'quasar/src/components/resize-observer/QResizeObserver.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSlider,QBtn,QCarousel,QCarouselSlide,QCarouselControl,QResizeObserver});
